var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-health" },
    [
      _c("p", { staticClass: "text large sybold" }, [_vm._v("基本健康信息")]),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v(
          " 出于对每个学生健康状况的关心和负责，我们要求你如实且完整地填写以下健康问卷。你填写的信息按照分级程度将被上报给你在峰会期间的负责老师和主办学校，并用于现场的管理和照顾。同时峰会组委会将为每一位录取的学生购买意外伤害险，因此需要学生提供必要的信息。 "
        )
      ]),
      _c("p", { staticClass: "text mt-10" }, [
        _vm._v(
          " 健康信息本身不会影响你的峰会录取资格，但由于峰会活动在公立学校内部举办，医疗条件和应急预案完全按照学校日常的标准实施，无法满足学生部分特殊的医疗需求，你在同意出席时，即需要了解并认可这些软硬件限制。如在活动进行中我们认为你在生理或心理健康上暂时不适宜继续参加峰会活动的，我们有权联系你的监护人或紧急联系人，单独安排活动甚至延后本次活动资格，等到身体状况恢复后，再来参加。如果发生故意隐瞒健康状况，由此造成的一切后果，将由你和监护人共同承担，组委会也将视情形的严重程度决定是否取消学生未来参加其他哈佛在华青少年系列活动的资格。 "
        )
      ]),
      _c("p", { staticClass: "text mt-10 sybold" }, [
        _vm._v(
          " 当你提交本健康信息登记表就视为你已经完全阅读、知悉并同意本表中全部内容。如果本表中的内容在峰会之前发生任何变化，请再次填写本表，更新相应信息。 "
        )
      ]),
      _c("p", { staticClass: "text sybold mt-30" }, [
        _vm._v("学生在峰会期间是否需要使用特殊药物？")
      ]),
      _c("RadioGroupPropotype", {
        attrs: {
          className: "radio-group-wrap mt-20",
          options: _vm.QUESTIONS.MEDICINE_OPTIONS
        },
        model: {
          value: _vm.form.q1,
          callback: function($$v) {
            _vm.$set(_vm.form, "q1", $$v)
          },
          expression: "form.q1"
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowQ1Complete,
              expression: "isShowQ1Complete"
            }
          ]
        },
        [
          _c("p", { staticClass: "text sybold mt-30" }, [
            _vm._v("请具体描述药物名称、用药频率和注意事项")
          ]),
          _c(
            "div",
            { staticClass: "flex-line mt-10 long" },
            [
              _c("TextareaPrototype", {
                attrs: { counter: false, placeholder: "" },
                model: {
                  value: _vm.form.q1_complete,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "q1_complete", $$v)
                  },
                  expression: "form.q1_complete"
                }
              })
            ],
            1
          )
        ]
      ),
      _c("p", { staticClass: "text sybold mt-30" }, [
        _vm._v("你是否在过去的12个月里出现过以下症状或行为？")
      ]),
      _c("CheckboxGroupPrototype", {
        attrs: {
          className: "radio-group-wrap mt-20",
          options: _vm.QUESTIONS.SYMPTOM_OPTIONS
        },
        model: {
          value: _vm.form.q2,
          callback: function($$v) {
            _vm.$set(_vm.form, "q2", $$v)
          },
          expression: "form.q2"
        }
      }),
      _c("p", { staticClass: "text sybold mt-30" }, [
        _vm._v("你是否在过去的12个月里接受过如下治疗？")
      ]),
      _c("CheckboxGroupPrototype", {
        attrs: {
          className: "radio-group-wrap mt-20",
          options: _vm.QUESTIONS.CURE_WAYS_OPTIONS
        },
        model: {
          value: _vm.form.q3,
          callback: function($$v) {
            _vm.$set(_vm.form, "q3", $$v)
          },
          expression: "form.q3"
        }
      }),
      _c("p", { staticClass: "text sybold mt-30" }, [
        _vm._v("你是否在过去的12个月里接受过如下治疗？")
      ]),
      _c("CheckboxGroupPrototype", {
        attrs: {
          className: "radio-group-wrap mt-20 no-flex",
          options: _vm.QUESTIONS.CURE_DISEASE_OPTIONS
        },
        model: {
          value: _vm.form.q4,
          callback: function($$v) {
            _vm.$set(_vm.form, "q4", $$v)
          },
          expression: "form.q4"
        }
      }),
      _c("p", { staticClass: "text sybold mt-30" }, [
        _vm._v(
          " 任何问题选是，请详细说明具体的疾病情况、时间和严重程度。如上述问题无法涵盖你的情况，请你具体描述其他我们需要知晓的情况（如无，请填写无） "
        )
      ]),
      _c(
        "div",
        { staticClass: "flex-line mt-10 long" },
        [
          _c("TextareaPrototype", {
            attrs: { counter: false, placeholder: "" },
            model: {
              value: _vm.form.q5,
              callback: function($$v) {
                _vm.$set(_vm.form, "q5", $$v)
              },
              expression: "form.q5"
            }
          })
        ],
        1
      ),
      _c("p", { staticClass: "text sybold mt-20" }, [
        _vm._v(
          " 如果因为宗教、身体健康等原因，你有任何饮食上的特殊要求，请具体说明情况进行告知，主办学校食堂会参照日常学校操作标准，尽力进行准备（如无，请填写无） "
        )
      ]),
      _c(
        "div",
        { staticClass: "flex-line mt-10 long" },
        [
          _c("TextareaPrototype", {
            attrs: { counter: false, placeholder: "" },
            model: {
              value: _vm.form.q6,
              callback: function($$v) {
                _vm.$set(_vm.form, "q6", $$v)
              },
              expression: "form.q6"
            }
          })
        ],
        1
      ),
      _c(
        "Button",
        {
          staticClass: "btn-submit mt-30",
          on: { click: _vm.handleClickSubmit }
        },
        [_vm._v("提交")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }